// @flow

const timeStamp = new Date().getTime();
const DEFAULT_TILE = 'Narita Express Guide - Search trains from Narita Airport';
const DEFAULT_DESCRIPTION =
  'Naexguide is the quickest way to find Narita Express trains to Tokyo, Shinjuku and Shibuya from Narita Airport. Find information about Narita Express trains, timetables, tickets, prices and routes. Search Narita Express train times to and from Narita Airport on Naexguide.';

export const defaultSeoConfig = {
  title: DEFAULT_TILE,
  description: DEFAULT_DESCRIPTION,
  url: 'https://www.naexguide.com',
  openGraph: {
    title: DEFAULT_TILE,
    description: DEFAULT_DESCRIPTION,
    type: 'website',
    images: [
      {
        url: `https://www.naexguide.com/og_image.png?${timeStamp}`,
        width: 500,
        height: 500,
        alt: 'Narita Express Guide',
      },
    ],
  },
  twitter: {
    cardType: 'summary',
  },
};
